
export  class Project {
    id:number;
    name:string;
    created_by:number;
    updated_by:number;
    created_at:Date;
    updated_at:Date;
    selected?:boolean;
}